import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Alert } from 'tdesign-react';
import { CloseIcon } from 'tdesign-icons-react';
import { isVoid, shouldShowMessage } from '@/utils/common';
import NoDisplayModal from './NoDisplayModal';

function GlobalHeaderWarn({ globalWarn }) {
  // 取第一个
  const firstGlobalWarn = globalWarn[0] || {};
  const { message, theme = 'warning', type } = firstGlobalWarn;
  const [visible, setVisible] = useState(false);
  const [dialogVisible, setDialogVisible] = useState(false);

  useEffect(() => {
    setVisible(false);
    // 没有信息不显示
    if (isVoid(message)) return;

    // 如果消息需要显示
    if (shouldShowMessage(type)) {
      setVisible(true);
    }
  }, [message, type]);

  const onCloseClick = (e) => {
    e.stopPropagation();
    setDialogVisible(true);
  };

  return (
    visible && (
      <>
        <Alert theme={theme} message={message} close={() => <CloseIcon onClick={onCloseClick} />} />
        <NoDisplayModal visible={dialogVisible} onClose={() => setDialogVisible(false)} />
      </>
    )
  );
}

export default connect((state) => ({
  globalWarn: state.layout.globalWarn,
}))(GlobalHeaderWarn);
